import script from "./Login.vue?vue&type=script&setup=true&lang=js"
export * from "./Login.vue?vue&type=script&setup=true&lang=js"

import "./Login.vue?vue&type=style&index=0&id=67135a0e&lang=scss&scoped=true"

import exportComponent from "/home/ecs-user/software/jenkins/workspace/smallshop-website-uat/smallshop-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67135a0e"]])

export default __exports__